import api from "../../../api";
import React, { useEffect } from "react";
import utils from "../../../utils";
import values from "../../../values";
import Context from "../../../context";
import UserScreen from "../index";

import { TModal } from "../../../types/common.type";
import { useQuery } from "react-query";
import {
  ICreateAndUpdateUser,
  IFindTicketInformation,
  IReplyTicket,
} from "../../../types/common.interface";

const TicketContainer = () => {
  // ** ====================================================================================================================
  // ** --------------------------------------------------------------------------------------------------------------------
  // **                                               Value Validations
  // ** --------------------------------------------------------------------------------------------------------------------

  const [showModal, setShowModal] = React.useState<TModal>("NONE");
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [selectedTicket, setSelectedTicket] = React.useState<any>();
  const [requestTicket, setRequestTicket] =
    React.useState<IFindTicketInformation>({
      page: 1,
      limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
      search: { base: "", value: "" },
      filters: {
        province: undefined,
        city: undefined,
        // type: utils.stringHexConversion.reverse(
        //   Cookies.get(constants.USER.TYPE) as string
        // ),
      },
    });
  // ** --------------------------------------------------------------------------------------------------------------------
  // ** ====================================================================================================================

  // !! ====================================================================================================================
  // !! --------------------------------------------------------------------------------------------------------------------
  // !!                                                Start API Cal
  // !! --------------------------------------------------------------------------------------------------------------------
  // const resultTicket = { data: { result: { docs: [] } } };

  const resultTicket = useQuery(
    [
      values.useQueryKeys.getAllTicket,
      requestTicket?.page,
      requestTicket?.search?.value,
      requestTicket?.filters,
    ],
    () =>
      api.post.common.findTicket({
        filters: requestTicket?.filters,
        search: requestTicket?.search,
        limit: requestTicket?.limit,
        page: requestTicket?.page,
      })
  );
  const refetchTickets = resultTicket.refetch;

  // !! --------------------------------------------------------------------------------------------------------------------
  // !! ====================================================================================================================

  // ** ====================================================================================================================
  // ** --------------------------------------------------------------------------------------------------------------------
  // **                                               Local Functions
  // ** --------------------------------------------------------------------------------------------------------------------

  useEffect(() => {
    setSelectedTicket(
      resultTicket?.data?.result?.docs?.find(
        (item: any) => item?._id === selectedTicket?._id
      )
    );
  }, [resultTicket]);
  async function replyTicketFunction(formData: IReplyTicket) {
    setIsLoading(true);
    const result = await api.post.common.replyTicket(formData);
    if (result) {
      utils.successHandler(Number(2010)); // result.CODE === 2021
      resultTicket.refetch();
      // setShowModal("NONE");
      setIsLoading(false);
      return true;
    }
    setIsLoading(false);
    return false;
  }
  async function createFunction(formData: ICreateAndUpdateUser) {
    setIsLoading(true);
    const result = await api.post.administrator.createAdmin(formData);
    if (result) {
      utils.successHandler(Number(2010)); // result.CODE === 2021
      resultTicket.refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }
  async function updateFunction(formData: ICreateAndUpdateUser) {
    setIsLoading(true);
    const result = await api.put.administrator.updateAdmin(formData);
    if (result) {
      utils.successHandler(Number(2010)); // result.CODE === 2021
      resultTicket.refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }

  // async function deleteFunction(userId: string) {
  //   setIsLoading(true);
  //   const result = await api.dele.administrator.deleteUser(userId);
  //   if (result) {
  //     utils.successHandler(Number(2010)); // result.CODE === 2021
  //     // resultTicket.refetch();
  //     setShowModal("NONE");
  //   }
  //   setIsLoading(false);
  //   return false;
  // }
  // ** --------------------------------------------------------------------------------------------------------------------
  // ** ====================================================================================================================

  // ?? ====================================================================================================================
  // ?? --------------------------------------------------------------------------------------------------------------------
  // ??                                                JSX Container
  // ?? --------------------------------------------------------------------------------------------------------------------
  return (
    <Context.TicketScreen.Provider
      value={{
        showModal,
        isLoading,
        setShowModal,
        setIsLoading,
        updateFunction,
        createFunction,
        requestTicket,
        selectedTicket,
        setRequestTicket,
        setSelectedTicket,
        replyTicketFunction,
        refetchTickets,
      }}
    >
      <UserScreen rqUser={resultTicket} />
      {/* <DeleteModal
        open={showModal === "DELETE"}
        user={selectedUser}
        data={selectedUser}
        loading={isLoading}
        onClose={() => setShowModal("NONE")}
        onSubmit={deleteFunction}
      /> */}
    </Context.TicketScreen.Provider>
  );

  // ?? --------------------------------------------------------------------------------------------------------------------
  // ?? ====================================================================================================================
};

export default TicketContainer;
